<template>
  <div>
    <McButton
      variant="secondary"
      :text="$t('global.back')"
      icon="icon-outline_arrow-left"
      @click="handleBack"
    />

    <b-modal
      class="mc-modal"
      id="mc-modal-back"
      ref="mc-modal-back"
      title="Konfirmasi"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>Apakah Anda yakin ingin meninggalkan halaman ini?</p>
        <p>Data tidak akan tersimpan.</p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex mx-0">
          <McButton
            @click="$router.push({ name: 'Master Vendor' })"
            variant="secondary"
            class="me-2"
            text="Keluar Halaman"
          />

          <McButton @click="cancel()" variant="primary" text="Tetap di Halaman" />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    hasChanged: {},
  },
  methods: {
    handleBack() {
      if (this.hasChanged) {
        return this.$refs['mc-modal-back'].show()
      }

      this.$router.push({ name: 'Master Vendor' })
    }
  }
}
</script>
